import { render, staticRenderFns } from "./ModuleRegisterDomain.vue?vue&type=template&id=27e33d1d"
import script from "./ModuleRegisterDomain.vue?vue&type=script&lang=js"
export * from "./ModuleRegisterDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports